export const flexMultiPrep = {
  title: 'Flex+ Multi-Prep Set',
  class: 'intro-starter',
  text: `<ul>
<li>
<span class="b">#100272</span>
</li>
<li>
<span class="b">USD</span> $329 | <span class="b">CAD</span> $429
</li>
<li>1-year guarantee</li>
<li>
Dishwasher-safe: Immersion attachment, container, beaters, whisks,
bowl, post, guard, pusher, and blades. Hand wash: food processor
lid. Wipe clean: Power handle, hand mixer attachment, batteries, and
charging station.
</li>
<li>
Immersion blender: 17" (44 cm).
<br /> 6-cup (1.5-L) food processor:
17" (44 cm).
<br /> Hand mixer: 13½" (34 cm).
</li>
<li>Includes the power handle, two rechargeable lithium-ion batteries, charging station, immersion blender attachment, blending container with lid, hand mixer attachment, two beaters, two whisks, food processor attachment, food pusher, reversible grating blade, reversible slicing blade, multiuse blade, and a cooking guide.</li>
<li>
Get a food processor, hand mixer, and immersion blender in one with
no strings, or cords, attached. This cordless prep tool does the
work so you don’t have to.
</li>
<li>
Just click the power handle to one of the attachments, choose a
blade or beaters/whisks, pop on one of the batteries, and you’re
ready to go. The two rechargeable batteries give you about 60
minutes of total run time.
</li>
<li>
The power handle has push-button control for comfortable one-handed
operation. Five speeds (three for the hand mixer) easily adjust
during use for flexibility and control over your recipe. Plus,
indicator lights show how much battery life is left and the speed
you’re using. A safety lock prevents the Flex+ from accidentally
turning on.
</li>
<li>
With one fully charged battery, you can blend up to 93 bowls of soup, mix up to 576 2" (5-cm) cookies, or chop up to 60 onions.
<span style="font-style: italic;"> Based on: 11 batches of tomato soup (12-oz./350-mL bowl each), 16 batches of chocolate chip cookies, and an onion size of 3–3.5 oz. (90–110 g).</span>
</li>
<li>
<span class="b">Immersion blender:</span> Big jobs or small, its
slim size, stainless blade, and cookware-safe design means you
control the texture of the foods you blend. It blends, emulsifies,
froths, purees, and whips. Blending container helps make homemade
mayonnaise and dressings in under two minutes.</li>
<li>
<span class="b">Great for:</span> velvety smooth soups and gravies,
all kinds of sauces such as pesto, tomato, chimichurri, barbecue,
homemade dips, dressings, marinades, mayonnaise, milkshakes,
smoothies, and more.
</li>
<li>
<span class="b">6-cup (1.5-L) Food Processor:</span>
The multiuse blade can cut foods to the size and texture you want,
even purees. The grating blade is reversible so you can coarsely or
finely grate fresh ingredients in no time. The slicing blade slices
and shaves any firm produce.
</li>
<li>
<span class="b">Great for:</span>
Grating broccoli and Brussels sprouts for salads, cabbage for slaw,
carrots for cake, and cheese for everything. Slicing veggies for
salads and sautes, potatoes and zucchini for gratins, and apples.
(Please note, the slicing blade won’t slice cheese.)
</li>

<li>
<span class="b">Hand Mixer:</span>
Mix, beat, incorporate, and whip together whatever you're making.</li>
<li>
<span class="b">Great for:</span>
Eggs, batters meringues mashed potatoes whipped cream, frothy egg
whites, and more.
</li>
<li><span class="b teal-text">Get it at a discount or for free when you host a party.
Ask your consultant for details.</span></li>
</ul>
`,
  images: [
    { id: `gxmgevopra`, key: `nc1-gs1-1` },
    { id: `nswgebybga`, key: `nc1-gs1-2` },
    { id: `hqaavxqzhm`, key: `nc1-gs1-3` },
    { id: `iirve9xuhr`, key: `nc1-gs1-4` },
    { id: `3licxp34nn`, key: `nc1-gs1-5` },
    { contain: true, id: `mhkq0hjbhv`, key: `nc1-gs1-6` },
  ],
  videos: [
    ` <iframe src="https://player.vimeo.com/video/570400728" width="640" height="564" frameborder="0" allow="autoplay; fullscreen" allowfullscreen></iframe>`,
  ],
};
